<template>
  <div
    class="inactive-tag"
    :style="{
      position: position,
      top: top + 'px',
      left: left + 'px',
      right: right + 'px'
    }"
  >
    Inactive
  </div>
</template>

<script>
export default {
  name: "InactiveTag",

  props: {
    /**
     * Determines the position of the div (relative/absolute)
     */
    position: {
      type: String,
      default: "absolute"
    },

    /**
     * Determine the distance from the top, if the position is relative
     * it is relative to the parent component, if not, the distance is relative to the page.
     */
    top: {
      type: [Number, String],
      default: 0
    },

    /**
     * Determine the distance from the left, if the position is relative
     * it is relative to the parent component, if not, the distance is relative to the page.
     */
    left: {
      type: [Number, String],
      default: undefined
    },

    /**
     * Determine the distance from the right, if the position is relative
     * it is relative to the parent component, if not, the distance is relative to the page.
     */
    right: {
      type: [Number, String],
      default: undefined
    }
  }
};
</script>

<style scoped>
.inactive-tag {
  width: fit-content;
  height: fit-content;
  border: 1px solid var(--red);
  border-radius: 1px;
  color: var(--primary-highlight);
  padding: 2px 6px;
  font-size: 8px;
  text-transform: uppercase;
  line-height: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/_Atoms/InactiveTag.vue